<template>
  <section class="video_promotion_area text-center">
    <div class="overlay">
      <h1>Choose the Best</h1>

    </div><!--end .overlay-->
  </section>
</template>

<script>
    export default {
      name: "Promotion"
    }
</script>

<style scoped>

</style>
